/* eslint-disable no-unused-vars */
import { Accordion, AccordionDetails, AccordionSummary, Typography, } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import React from 'react';
export var AccordionWrapper = function (_a) {
    var name = _a.name, children = _a.children, expanded = _a.expanded, onChange = _a.onChange;
    return (React.createElement(Accordion, { expanded: expanded, onChange: onChange },
        React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMore, null) },
            React.createElement(Typography, { variant: 'body2' }, name)),
        React.createElement(AccordionDetails, null, children)));
};
AccordionWrapper.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=AccordionWrapper.js.map